import { useRef } from "react";
import { CalendarDays } from "lucide-react";
import { NeuInput } from "./Neu";

// iOS/WKWebView keeps the intrinsic width of input[type=date] and centres its value,
// so min-w-0 + explicit value alignment are required to stop it overflowing the card.
const IOS_SAFE = [
  "w-full min-w-0 appearance-none pr-11 pl-4 text-left",
  "[&::-webkit-date-and-time-value]:text-left [&::-webkit-date-and-time-value]:w-full",
  "[&::-webkit-datetime-edit]:w-full [&::-webkit-datetime-edit]:p-0",
  "[&::-webkit-calendar-picker-indicator]:hidden",
  "[&::-webkit-inner-spin-button]:hidden [&::-webkit-clear-button]:hidden",
].join(" ");

// Date field styled exactly like the password field: neu input, icon button inside on the right.
export const DateInput = ({ label, testId, value, onChange, className = "", ...rest }) => {
  const wrap = useRef(null);

  const openPicker = () => {
    const input = wrap.current?.querySelector("input");
    if (!input) return;
    if (input.showPicker) input.showPicker();
    else input.focus();
  };

  return (
    <div className={`min-w-0 ${className}`}>
      {label ? <p className="label-xs mb-2">{label}</p> : null}
      <div className="relative min-w-0" ref={wrap}>
        <NeuInput
          data-testid={testId}
          type="date"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          dir="ltr"
          className={IOS_SAFE}
          {...rest}
        />
        <button
          type="button"
          tabIndex={-1}
          data-testid={`${testId}-calendar`}
          aria-label={label}
          onClick={openPicker}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground transition-colors duration-200 hover:text-primary"
        >
          <CalendarDays className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
